import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import StatCard from "./StatCard";
import DataTable from "./DataTable";
import PieChartCard from "./PieChartCard";
import BACKEND_URL from "../../config/config.js";
import EconoJournalLogo from "../../components/EconoJournalLogo";
import { showPopup } from "../../utils/popup";
import "../../App.css";

export default function PanelECJ() {
  const navigate = useNavigate();
  const [codes, setCodes] = useState([]);
  const [registrosTotales, setRegistrosTotales] = useState(0);
  const [userDetails, setUserDetails] = useState([]);
  const [ecj, setEcj] = useState(null);

  const handlePrint = () => {
    window.print();
  };

  const handleExportExcel = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/panel-ecj/export-excel`);
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const blob = await res.blob();
      const disposition = res.headers.get("content-disposition") || "";
      const match = disposition.match(/filename="(.+)"/);
      const filename = match?.[1] || "panel_ecj.xlsx";

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting Excel:", error);
      showPopup("No se pudo descargar el archivo Excel. Intentá nuevamente.", {
        title: "Error al exportar",
        type: "error",
      });
    }
  };

  useEffect(() => {
    fetch(`${BACKEND_URL}/dashboard-tables`)
      .then((res) => res.json())
      .then((response) => {
        setCodes(response.codes || []);
        setUserDetails(response.user_details || []);
      })
      .catch((error) => {
        console.error("Error al obtener tablas del dashboard:", error);
      });

    fetch(`${BACKEND_URL}/ecj-stats`)
      .then((res) => res.json())
      .then((response) => {
        setEcj(response);
      })
      .catch((error) => {
        console.error("Error al obtener ECJ stats:", error);
      });

    fetch(`${BACKEND_URL}/visual-data`)
      .then((res) => res.json())
      .then((response) => {
        setRegistrosTotales(response.registrosTotales || 0);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });
  }, []);

  const middleIndex = Math.ceil(codes.length / 2);
  const firstColumnCodes = codes.slice(0, middleIndex);
  const secondColumnCodes = codes.slice(middleIndex);
  return (
    <div className="container panel-ecj-print">
        <div className="printPageOne">
          <DashboardHeader
          logo={<EconoJournalLogo className="logoECJ" />}
          actions={
            <>
              <button className="btnPrint" onClick={() => navigate("/config")}>
                Config
              </button>
              <button className="btnPrint" onClick={handleExportExcel}>
                Export Excel
              </button>
              <button className="btnPrint" onClick={handlePrint}>
                Imprimir
              </button>
            </>
          }
        />

        {ecj && (
          <div className="panelChartsGrid printChartsBlock">
            <div className="card-2 panelChartCard">
              <PieChartCard
                title="¿Cuál considerás que es hoy el principal desafío para sostener una nueva etapa de expansión del mercado eléctrico argentino?"
                data={ecj.reforms_probability || []}
              />
            </div>

            <div className="card-2 panelChartCard">
              <PieChartCard
                title="¿Qué tecnología debería tener mayor protagonismo en las próximas inversiones del sector eléctrico?"
                data={ecj.priority_segment || []}
              />
            </div>

            <div className="card-2 panelChartCard">
              <PieChartCard
                title="¿Qué grado de confianza tenés en que la reforma del mercado eléctrico genere nuevas inversiones privadas durante los próximos tres años?"
                data={ecj.renewables_outlook || []}
              />
            </div>
          </div>
        )}
      </div>

      <div className="printPageTwo">
        <StatCard
          title="Cantidad de registros"
          value={`${registrosTotales} registros`}
          className="card"
        />

        <div className="card">
          <div className="configPageHeader configPageHeaderWithAction">
            <h2>Códigos de invitación</h2>
            <button
              className="btnPrint"
              onClick={() => navigate("/config/invitation-codes")}
            >
              Gestionar códigos
            </button>
          </div>

          <div className="cont2Col">
            <DataTable
              className="print-table-wrapper"
              tableClassName="table2Col print-table"
              data={firstColumnCodes}
              rowKey="id_invitation_code"
              columns={[
                { key: "id_invitation_code", label: "ID" },
                { key: "code", label: "Código" },
                { key: "is_active", label: "Activo" },
                { key: "usage_count", label: "Usos" },
                { key: "usage_limit", label: "Límite" },
              ]}
              getRowProps={(code) => ({
                style: {
                  backgroundColor:
                    code.usage_limit !== null &&
                    code.usage_count >= code.usage_limit
                      ? "#ffd6d6"
                      : "transparent",
                },
              })}
              renderRow={(code) => (
                <>
                  <td>{code.id_invitation_code}</td>
                  <td>{code.code}</td>
                  <td>{code.is_active ? "Sí" : "No"}</td>
                  <td>{code.usage_count}</td>
                  <td>{code.usage_limit}</td>
                </>
              )}
            />

            <DataTable
              className="print-table-wrapper"
              tableClassName="table2Col print-table"
              data={secondColumnCodes}
              rowKey="id_invitation_code"
              columns={[
                { key: "id_invitation_code", label: "ID" },
                { key: "code", label: "Código" },
                { key: "is_active", label: "Activo" },
                { key: "usage_count", label: "Usos" },
                { key: "usage_limit", label: "Límite" },
              ]}
              getRowProps={(code) => ({
                style: {
                  backgroundColor:
                    code.usage_limit !== null &&
                    code.usage_count >= code.usage_limit
                      ? "#ffd6d6"
                      : "transparent",
                },
              })}
              renderRow={(code) => (
                <>
                  <td>{code.id_invitation_code}</td>
                  <td>{code.code}</td>
                  <td>{code.is_active ? "Sí" : "No"}</td>
                  <td>{code.usage_count}</td>
                  <td>{code.usage_limit}</td>
                </>
              )}
            />
          </div>
        </div>
      </div>

      <div className="printUsersTableSection">
        <DataTable
          title="Detalles completos de inscriptos"
          className="print-table-wrapper"
          tableClassName="print-table"
          data={userDetails}
          rowKey="id_user_response"
          columns={[
            { key: "first_name", label: "Nombre" },
            { key: "last_name", label: "Apellido" },
            { key: "email", label: "Email" },
            { key: "phone", label: "Teléfono" },
            { key: "company", label: "Empresa" },
            { key: "invitation_code", label: "Código" },
            { key: "payment_status", label: "Estado de pago" },
          ]}
          renderRow={(user) => (
            <>
              <td>{user.first_name}</td>
              <td>{user.last_name}</td>
              <td>{user.email}</td>
              <td>{user.phone}</td>
              <td>{user.company || "-"}</td>
              <td>{user.invitation_code || "-"}</td>
              <td>{user.payment_status || "-"}</td>
            </>
          )}
        />
      </div>

      <h4 className="printTitle">Reporte generado por Svant para</h4>
      <h4 className="printTitle">
        <b id="eventName">EconoJournal</b>
      </h4>
    </div>
  );
}
